import React from 'react';
import { components, FilterOptionOption } from 'react-select';
import { Button, Icon, IconSize, IconType, ISelectGroup, ISelectOption, Select } from 'ui-toolkit';
import type { ISpecificException } from '../../classes/ISpecificExceptions';
import { ReqExcSections } from '../../classes/ReqExcSections';

export interface IAddCustomReqExc {
  options: ISpecificException[];
  onDeleteClick: () => void;
  onCreateClick: (item: ISpecificException) => void;
  addCustomItem: (sectionName: ReqExcSections, text: string) => void;
  section: ReqExcSections;
}

interface IAddCustomReqExcState {
  customText: string | null;
  newItem: ISpecificException | null;
}

export class AddCustomReqExc extends React.Component<IAddCustomReqExc, IAddCustomReqExcState> {
  public static defaultProps: Partial<IAddCustomReqExc> = {};

  public readonly state: IAddCustomReqExcState = {
    customText: null,
    newItem: null,
  };

  private placeHolderText = `Start typing to add ${this.props.section === ReqExcSections.B1 ? 'a requirement' : 'an exception'} ...`;

  public render() {
    return (
      <div className="requirements-exceptions--row">
        <div className={'section-1-3'}>
          <Select
            options={this.getOptionsText()}
            placeholder={this.placeHolderText}
            openMenuOnClick={false}
            filterOption={this.filterOptions}
            components={{
              NoOptionsMessage: this.NoOptionsMessage,
            }}
            inputValue={this.state.customText ? this.state.customText : ''}
            onInputChange={this.onCustomItemChanged}
            classNamePrefix={'react-select'}
            onChange={this.onOptionSelected}
          />
        </div>
        <div />
        <div className="requirements-exceptions--align-right">
          <button onClick={this.props.onDeleteClick}>
            <Icon type={IconType.Remove} size={IconSize.Small} />
          </button>
        </div>
      </div>
    );
  }

  private filterOptions = (option: FilterOptionOption<ISelectOption<ISpecificException>>, inputValue: string) => {
    const searchString = inputValue.toLowerCase();
    const subject = option.data.value.subject ?? '';
    return subject.toLowerCase().includes(searchString);
  };

  private NoOptionsMessage = (props: any) => {
    return (
      components.NoOptionsMessage && (
        <components.NoOptionsMessage {...props}>
          <Button intent="ghost" isInline onClick={this.addCustomItem} disabled={false}>
            + Add custom
          </Button>
        </components.NoOptionsMessage>
      )
    );
  };

  private addCustomItem = () => {
    if (this.state.customText) {
      this.props.addCustomItem(this.props.section, this.state.customText);
    }
  };

  private onCustomItemChanged = (text: string) => {
    this.setState((state) => ({
      ...state,
      customText: text,
    }));
  };

  private onOptionSelected = (option: ISelectOption<ISpecificException> | null) => {
    if (!option) {
      return;
    }
    this.setState((state) => ({
      ...state,
      newItem: option.value,
    }));
    if (option.value) {
      this.props.onCreateClick(option.value);
    }
  };

  private getOptionsText = () => {
    const groupMap = new Map<string, ISelectGroup<ISpecificException>>();
    this.props.options.forEach((item) => {
      const subjectKey = item.subject ?? 'Uncategorized Subject';
      const subjectLabel = subjectKey.replace(/_/g, ' ');
      const option: ISelectOption<ISpecificException> = { label: item.template, value: item };
      const group = groupMap.get(subjectKey);
      if (!group) {
        groupMap.set(subjectKey, { label: subjectLabel, options: [option] });
      } else {
        group.options.push(option);
      }
    });
    return Array.from(groupMap.values());
  };
}
